import { render, staticRenderFns } from "./formCourseRecord.vue?vue&type=template&id=322d11d8&scoped=true&"
import script from "./formCourseRecord.vue?vue&type=script&lang=js&"
export * from "./formCourseRecord.vue?vue&type=script&lang=js&"
import style0 from "./formCourseRecord.vue?vue&type=style&index=0&id=322d11d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322d11d8",
  null
  
)

export default component.exports